<script setup>
import Details from './Details.vue';
import Overlay from './Overlay.vue';
</script>

<template>
    <div class="ConfiguratorOverlays tw-w-full lg:tw-w-8/12 tw-absolute lg:tw-top-0 tw-left-0 tw-bottom-0 tw-z-[60] lg:tw-z-auto">
        <Details />
        <Overlay />
    </div>
</template>
